// libs
import type { ReactNode } from 'react';
// components
import Page403 from '../statusPages/Page403';
// services
import useAuthorization from './authorizationService';
import { Permission } from './utils';

type GlobalProtectedRouteProps = {
  path?: string;
  exact?: boolean;
  globalPermissionToCheck: Permission | Permission[];
  children: ReactNode;
};

const GlobalProtectedRoute = (props: GlobalProtectedRouteProps) => {
  const { isGranted } = useAuthorization();
  const { globalPermissionToCheck, children } = props;

  return isGranted(globalPermissionToCheck) ? children : <Page403 />;
};

export default GlobalProtectedRoute;
